import { ReactNode, cloneElement, isValidElement, HTMLProps } from 'react';
import { usePopoverContext } from './context';

interface PopoverTriggerProps {
    children: ReactNode;
}

export function PopoverTrigger({
    children,
    ...htmlProps
}: HTMLProps<HTMLElement> & PopoverTriggerProps) {
    const { refs, getReferenceProps } = usePopoverContext();

    if (!isValidElement(children)) {
        return null;
    }

    return cloneElement(
        children,
        getReferenceProps({
            ref: refs.setReference,
            ...htmlProps,
        }),
    );
}
